import React, { useState } from "react";
import style from "./ProfileDropdown.module.scss";
import { Avatar, Typography, Divider, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { clearOnLogout, getCurrentUser } from "@/lib/utils";
import { clear } from "@/store/slices/globalSlice";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "@/store/store";
import routes from "@/routes/routes";
import toast from "@/lib/toast";

const ProfileDropdown: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const userName = localStorage.getItem("username");
  const Email = localStorage.getItem("otpEmail");
  const getInitials = (name: string) => {
    if (!name) return "U";
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const logout = async () => {
    try {
      clearOnLogout();
      dispatch(clear());
      toast.success("Logged out successfully");
       navigate( "/", { replace: true });
    } catch (error) {
      toast.error("Something went wrong during logout");
    }
  };
  return (
    <div className="bg-white rounded-2xl shadow-2xl w-[300px] flex flex-col overflow-hidden">
      {/* Top Section */}
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        p={2}
        sx={{
          background: "linear-gradient(135deg, #0048BA 0%, #4F7CF7 100%)",
          color: "white",
        }}
      >
        <div className={style.avatarCircle}>
              {getInitials(userName || "XYZ")}
          </div>
        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            {userName}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            {Email}
          </Typography>
        </Box>
      </Box>

      {/* Sign Out */}
      <Box p={3}>
        <Button variant="outlined" onClick={logout}>
          SIGN OUT
        </Button>
      </Box>
    </div>
  );
};

export default ProfileDropdown;
